import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnDestroy,
  Optional,
  output,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { iframeResizer } from 'iframe-resizer';

import { PdfViewerConfigNotProvidedError } from './pdf-viewer-config-not-provided-error';
import { PDF_VIEWER_CONFIG_TOKEN } from './pdf-viewer.di';
import { PdfViewerConfig } from './pdf-viewer.types';

@Component({
  selector: 'rt-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class PdfViewerComponent implements OnDestroy {
  public static ngAcceptInputType_assetUrl: string | SafeResourceUrl;

  @Input()
  public set assetUrl(url: SafeResourceUrl) {
    this.safeAssetUrl = this.getViewerUrl(url);
  }

  public get assetUrl(): SafeResourceUrl {
    return this.safeAssetUrl;
  }

  public CDNHost: string = '';
  public viewerDirectory: string = '';

  @Input() public minHeight: string = '700px';

  // https://github.com/davidjbradshaw/iframe-resizer/blob/master/docs/parent_page/options.md#heightcalculationmethod
  @Input() public heightCalculationMethod: string = 'max';

  public iframeLoad = output<HTMLIFrameElement>();

  private safeAssetUrl: SafeResourceUrl;

  private iframes: IFrameResizerFrame[] = [];

  constructor(
    private sanitizer: DomSanitizer,
    @Optional() @Inject(PDF_VIEWER_CONFIG_TOKEN) private config: PdfViewerConfig,
  ) {
    if (config && config.CDNHost && config.viewerDirectory) {
      this.CDNHost = config.CDNHost;
      this.viewerDirectory = config.viewerDirectory;
    } else {
      throw new PdfViewerConfigNotProvidedError();
    }
  }

  public onIframeLoad(frame: HTMLIFrameElement): void {
    this.iframes = iframeResizer(
      {
        heightCalculationMethod: this.heightCalculationMethod,
        checkOrigin: [this.CDNHost],
        scrolling: true,
      },
      frame,
    );
    this.iframeLoad.emit(frame);
  }

  public ngOnDestroy(): void {
    this.iframes.forEach(frame => frame.iFrameResizer.close());
  }

  private getViewerUrl(assetUrl: SafeResourceUrl): SafeResourceUrl {
    // eslint-disable-next-line ban/ban
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      // eslint-disable-next-line @typescript-eslint/no-base-to-string
      `${this.CDNHost}/${this.viewerDirectory}/web/viewer.html?file=${assetUrl}#pagemode=none`,
    );
  }
}
